import { FeedbackForm } from "./FeedbackForm";
import { Terms } from "./Terms";
import logo from '../logo.png';

export const MainPage = () => {
  return (
    <div>
      <header className="main__header">
        <img src={logo} className="main__logo-img" alt="logo"></img>
      </header>
      <div className="main__about-us">
        <h2>UpFood app - your new approach to healthy nutrition</h2>
        <p className="about-us-text">
          Our main goal is to help you develop heathy nutrition habits.
          We are using recommendations of WHO to provide you with the best suggestions.
          Let's become better versions of ourselves together! Please tell us how we can improve our Service.
        </p>
      </div>
      <FeedbackForm />
      <div>
        <Terms />
      </div>
    </div>
  )
}